<template>
  <div class="main">
    <FormWrapper :action="formAction" :method="formMethod">
      <div class="title-bar">
        <h1 class="mb-0">{{ coupon.id ? "Edit" : "Add New" }} Coupon</h1>
        <a class="btn-back" :href="route('admin.coupons.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 mb-3 col-lg-4 pr-lg-4">
              <Field
                type="text"
                name="code"
                label="Coupon Code"
                :value="coupon.code"
                validate="required"
                validate-as="coupon code"
              />
            </div>
            <div class="col-12 mb-3 col-lg-8">
              <Field
                type="text"
                name="description"
                label="Description"
                :value="coupon.description"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3 pr-4">
              <Field
                type="select"
                name="type"
                label="Type"
                :value="coupon.type"
                :options="types"
                :hideSelectEmptyOption="true"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3 pr-4">
              <Field
                type="text"
                name="amount"
                label="Amount"
                :value="coupon.amount"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3 pr-4">
              <Field
                type="datepicker"
                name="start_date"
                label="Start Date"
                :value="coupon.start_date"
                validate="required"
                validate-as="start date"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3">
              <Field
                type="datepicker"
                name="end_date"
                label="End Date"
                :value="coupon.end_date"
                validate="required"
                validate-as="end date"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3 pr-4">
              <Field
                type="text"
                name="min_order"
                label="Minimum Subtotal"
                :value="coupon.min_order"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3 pr-4">
              <Field
                type="text"
                name="max_order"
                label="Maximum Subtotal"
                :value="coupon.max_order"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3 pr-4">
              <Field
                type="text"
                name="max_uses"
                label="Maximum No. of Uses"
                :value="coupon.max_uses"
                help-text="This is the total number of times this discount can be used across all users (leave empty or enter '0' for unlimited use)"
              />
            </div>
            <div class="col-12 mb-3 col-lg-3">
              <Field
                type="text"
                name="max_discount"
                label="Maximum Discount Total"
                :value="coupon.max_discount"
                help-text="This is the total amount across all purchases made with this discount that can be applied (leave empty or enter '0.00' for unlimited use)"
              />
            </div>
            <div class="col-12">
              <hr />
              <h4 class="text-primary text-uppercase mb-4">
                Limit to Select Courses
              </h4>
            </div>
            <div class="col-12">
              <MultiAssignField
                type="select"
                name="courses"
                :value="coupon.course_ids"
                :options="courses"
              />
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 mb-3 col-md-3 pt-lg-3 pr-lg-4">
              <Field
                type="checkbox"
                name="is_active"
                id="is_active"
                label="This coupon is ACTIVE"
                :value="!!coupon.is_active"
                :checkbox-value="1"
              />
            </div>
            <div class="col-12 mb-3 col-md-9">
              <div class="alert alert-info">
                Current Status: {{ coupon.status || "N/A" }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="text-center">
              <button type="submit" class="btn btn-success mr-2">
                Save Changes
              </button>
              <a class="btn btn-info" :href="route('admin.coupons.index')"
                >Cancel & Exit</a
              >
            </div>
            <div v-if="coupon.id" class="font-size-sm text-center pt-4">
              <span
                >Last updated on
                {{ coupon.updated_at | moment("MM/DD/YYYY") }}</span
              >
              <span>at {{ coupon.updated_at | moment("h:mma") }}</span>
              <span v-if="coupon.updatedBy">{{
                " " + coupon.updatedBy.name
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    coupon: { type: Object, required: true },
    types: { type: Array, required: true },
    courses: { type: Array, default: () => [] },
  },
  computed: {
    formAction() {
      return !this.coupon.id
        ? this.route("admin.coupons.store")
        : this.route("admin.coupons.update", {
            coupon: this.coupon.id,
          });
    },
    formMethod() {
      return !this.coupon.id ? "POST" : "PUT";
    },
  },
};
</script>